export default __webpack_public_path__ + "static/media/moodBad.4a71ad37.png";